import React from "react";
import {
    DatePicker,
    Table,
    Input,
    Icon,
    Form,
    message
} from 'antd';
import moment from 'moment';
import TitleTop from '@pages/Assembly/titleTop';
import { createUuid } from "@utils/NHCore";
import './index.css';
import { getLoginUser } from "@utils/NHCore";
import NHFetch from '@utils/NHFetch';
import NHSelect from '@components/common/NHSelect';

class XsgbForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            add: false,
            data: []         
        }
    }

    componentDidMount() {
        let userId = getLoginUser() ? getLoginUser().userId : undefined;
        this.userId = userId;
        this.queryEduExperience(userId)
    }
    queryEduExperience = xsid => {
        NHFetch('/newStudent/leader/record/get','GET').then(res=>{
            if (res && res.code == 200 && res.data) {
                this.setState({data:[...res.data]})
            }
        })
    }

    validateFields = (func)=>{
        let err = false;
        let formData = this.state.data;
        func(err,formData);
    }

    onAdd = () => {
        let { add, data } = this.state;
        if(!data){
            data = [];
        }
        if (add) {
            data.push({
                key: createUuid(),
                operation: ''
            });
            this.setState({
                data
            });
        }
        this.setState({
            add: true
        });
    };
  
    onDelete = (index) => {
        let { data } = this.state;
        data.splice(index,1);
        this.setState({
            data: data,
            add: true
        });
    };

    

    save = (cb) => {
        this.props.form.validateFields((err,values)=>{
            console.log(values);
            if (err) {
                cb(false);
                return;
            }
            values.list = values.list || []
            const list = values.list.map(item => {
                return {
                    ...item,
                    drsj:item.drsj.valueOf(),
                    lrsj:item.lrsj.valueOf()
                }
            });
            let userId = getLoginUser() ? getLoginUser().userId : undefined;
            NHFetch('/newStudent/leader/record/update','POST',list).then(res=>{
                if (res && res.code === 200 && res.data) {
                    this.queryEduExperience(userId)
                    cb(true);
                    this.setState({
                        edit: false,
                        add: false
                    });
                    this.props.updateBlzt()
                } else {
                    cb(false);
                }
            })
        })
    }

    /** 验证必填项 */
    validateCustom = () => {
        const { edit, formInitData } = this.state;
        if(edit) {
            // 若是编辑模式 使用表单验证
            this.props.form.validateFields((err,values) => {
                if(err) {
                    return false
                }
                return true
            })
        } else {
            return true
        }
    }
    
 
    render() {   
        const{initJtcyData, getChildComponent,form} = this.props;
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const{edit,data,add} = this.state;
        const formStyle = {
            margin:0
        }
        const columns = [
            {
                title: '当任时间',
                dataIndex:'drsj',
                render: (text, record,index) => {
                    return edit ? (
                        <Form.Item style={formStyle}>
                            {getFieldDecorator(`list.${index}.drsj`,{
                                initialValue:record.drsj?moment(record.drsj):undefined,
                                rules:[
                                    {
                                        validator: async (rule, value,callback) => {
                                            if (getFieldValue(`list.${index}.lrsj`) < value) {
                                                callback('当任时间必须小于离任时间');
                                                return;
                                            }
                                            callback();
                                        },
                                    },
                                    {required:true,message:'请选择当任时间'}
                                ]
                            })(
                                    <DatePicker />
                            )}
                        </Form.Item>
                    ) : record.drsj ? moment(record.drsj).format('YYYY-MM-DD'):'';
                }
            },
            {
                title: '离任时间',
                dataIndex:'lrsj',
                render: (text, record,index) => {
                    return edit ? (
                        <Form.Item style={formStyle}>
                            {getFieldDecorator(`list.${index}.lrsj`,{
                                initialValue:record.lrsj?moment(record.lrsj):undefined,
                                rules:[
                                    {
                                        validator: async (rule, value,callback) => {
                                            if (getFieldValue(`list.${index}.drsj`) > value) {
                                                callback('离任时间必须大于当任时间');
                                                return;
                                            }
                                            callback();
                                        }
                                    },
                                    {required:true,message:'请选择离任时间'}
                                ]
                            })(
                                <DatePicker />
                            )}
                        </Form.Item>
                    ) : record.lrsj  ? moment(record.lrsj).format('YYYY-MM-DD'):'';
                }
            },
            {
                title: '组织全称',
                dataIndex:'zzqc',
                render: (text, record,index) => {
                    return edit ? (
                        <Form.Item style={formStyle}>
                            {getFieldDecorator(`list.${index}.zzqc`,{
                                initialValue:text,
                                rules:[
                                    {required:true,message:'请输入组织全称'}
                                ]
                            })(
                                <Input
                                    maxLength={30}
                                    placeholder="组织全称"
                                />
                            )}
                        </Form.Item>
                        
                    ) : (
                        text
                    );
                }
            },
            {
                title: '部门',
                dataIndex:'bm',
                render: (text, record,index) => {
                    return edit ? (
                        <Form.Item style={formStyle}>
                            {getFieldDecorator(`list.${index}.bm`,{
                                initialValue:text,
                                rules:[
                                    {required:true,message:'请输入部门'}
                                ]
                            })(
                                <Input
                                    maxLength={30}
                                    placeholder="部门"
                                />
                            )}
                        </Form.Item>
                        
                    ) : (
                        text
                    );
                }
            },
            {
                title: '职务',
                dataIndex:'zw',
                render: (text, record,index) => {
                    return edit ? (
                        <Form.Item style={formStyle}>
                            {getFieldDecorator(`list.${index}.zw`,{
                                initialValue:text,
                                rules:[
                                    {required:true,message:'请输入职务'}
                                ]
                            })(
                                <Input
                                    maxLength={30}
                                    placeholder="部门"
                                />
                            )}
                        </Form.Item>
                        
                    ) : (
                        text
                    );
                }
            },
            {
                title: '组织级别',
                dataIndex:'zzjb',
                render: (text, record,index) => {
                    return edit ? (
                        <Form.Item style={formStyle}>
                            {getFieldDecorator(`list.${index}.zzjb`,{
                                initialValue:record.zzjb,
                                rules:[
                                    {required:true,message:'请选择组织级别'}
                                ]
                            })(
                                <NHSelect
                                    style={{width:140}}
                                    sign='DMK_XSXX_ZZJBM'
                                />
                            )}
                        </Form.Item>
                    ) : (
                        record.zzjbStr
                    );
                }
            }, 
            {
                title: '删除',
                dataIndex: 'operation',
                width: 80,
                render: (text, record,index) => {
                    if (edit) {
                        return (
                            <div className="editable-row-operations">
                                
                                <a
                                    onClick={() => this.onDelete(index)}
                                >
                                    <Icon
                                        type="close"
                                        style={{ color: 'red' }}
                                    />
                                </a>
                            </div>
                        );
                    }
                    return (
                        <a href="#">
                            <Icon type="delete" style={{ color: 'red' }} />
                        </a>
                    );
                }
            }
        ];           
       
        if(!edit){
            columns.pop();
        }
        return (
            <div>
                 <TitleTop
                    title="学生干部"
                    onEdit={type => {                       
                        this.setState({
                            edit: true,
                            add : true,
                        });
                    }}
                    onSave={cb => {
                        this.save(cb);
                    }}
                    onClose={() => {
                        this.queryEduExperience(this.userId)
                        this.setState({
                            edit: false,
                            add: false,
                        });
                    }}
                />
                <div className="p-sw">
                    <Table
                        bordered
                        size="middle"
                        pagination={false}
                        dataSource={data}
                        columns={columns}
                        rowKey={record=>record.key || record.pkid}
                    />
                    {add && (
                        <div
                            className="mt-10"
                            styleName="btn_add"
                            onClick={() => {
                                this.onAdd();
                            }}
                        >
                            添加
                        </div>
                    )}
                    <div style={{textAlign:'right',marginTop:5}}>提示：从小学开始填</div>
                </div>
            </div>   
        );
    }
}
export default Form.create()(XsgbForm);


// WEBPACK FOOTER //
// ./app/pages/SelfHelp/updateInfo/xsgbForm.js